export default __webpack_public_path__ + "static/media/button-spinner-gray.c36219dc.svg";